import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
//import VueGtm from 'vue-analytics';
import { locale, Switch } from 'iview';
import lang from 'iview/dist/locale/zh-TW';
import cloneDeep from 'lodash.clonedeep';
import App from './App';
import store from './store/index';
import router from './router';
import 'iview/dist/styles/iview.css';
import './scss/main.scss';

locale(lang);

Vue.config.productionTip = false;
Vue.prototype.$cloneDeep = cloneDeep;
Vue.component('i-switch', Switch);

Vue.use(Vuex);
Vue.use(Meta);
//Vue.use(VueGtm, {
  // container id
//  id: 'G-ZG5X6XGGQ2',
//  router,
  // enable track or not (optional)
 // enabled: process.env.NODE_ENV === 'production',
  // display console logs debugs or not (optional)
 // debug: false 
//})
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
  // mounted() {
  //   document.dispatchEvent(new Event('render-event'));
  // }
}).$mount('#app');
